/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationAttestation } from './HomeHealthCertificationAttestation';
import {
    HomeHealthCertificationAttestationFromJSON,
    HomeHealthCertificationAttestationFromJSONTyped,
    HomeHealthCertificationAttestationToJSON,
    HomeHealthCertificationAttestationToJSONTyped,
} from './HomeHealthCertificationAttestation';
import type { HomeHealthCertificationReviewReason } from './HomeHealthCertificationReviewReason';
import {
    HomeHealthCertificationReviewReasonFromJSON,
    HomeHealthCertificationReviewReasonFromJSONTyped,
    HomeHealthCertificationReviewReasonToJSON,
    HomeHealthCertificationReviewReasonToJSONTyped,
} from './HomeHealthCertificationReviewReason';
import type { HomeHealthCertificationEvidence } from './HomeHealthCertificationEvidence';
import {
    HomeHealthCertificationEvidenceFromJSON,
    HomeHealthCertificationEvidenceFromJSONTyped,
    HomeHealthCertificationEvidenceToJSON,
    HomeHealthCertificationEvidenceToJSONTyped,
} from './HomeHealthCertificationEvidence';

/**
 * 
 * @export
 * @interface HomeHealthCertificationCriteriaHomebound
 */
export interface HomeHealthCertificationCriteriaHomebound {
    /**
     * 
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     */
    review_reasons: Array<HomeHealthCertificationReviewReason>;
    /**
     * 
     */
    attestation: HomeHealthCertificationAttestation;
    /**
     * 
     */
    clinical_evidence: HomeHealthCertificationEvidence;
}



/**
 * Check if a given object implements the HomeHealthCertificationCriteriaHomebound interface.
 */
export function instanceOfHomeHealthCertificationCriteriaHomebound(value: object): value is HomeHealthCertificationCriteriaHomebound {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('review_reasons' in value) || value['review_reasons'] === undefined) return false;
    if (!('attestation' in value) || value['attestation'] === undefined) return false;
    if (!('clinical_evidence' in value) || value['clinical_evidence'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationCriteriaHomeboundFromJSON(json: any): HomeHealthCertificationCriteriaHomebound {
    return HomeHealthCertificationCriteriaHomeboundFromJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaHomeboundFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationCriteriaHomebound {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'review_reasons': ((json['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonFromJSON)),
        'attestation': HomeHealthCertificationAttestationFromJSON(json['attestation']),
        'clinical_evidence': HomeHealthCertificationEvidenceFromJSON(json['clinical_evidence']),
    };
}

export function HomeHealthCertificationCriteriaHomeboundToJSON(json: any): HomeHealthCertificationCriteriaHomebound {
    return HomeHealthCertificationCriteriaHomeboundToJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaHomeboundToJSONTyped(value?: HomeHealthCertificationCriteriaHomebound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'review_reasons': ((value['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonToJSON)),
        'attestation': HomeHealthCertificationAttestationToJSON(value['attestation']),
        'clinical_evidence': HomeHealthCertificationEvidenceToJSON(value['clinical_evidence']),
    };
}

